import React, { useMemo, useState } from "react";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { handleGetRequest } from "../../services/GetTemplate";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import { useLocation } from "react-router-dom";
import { Tooltip } from "react-tippy";
import ClipLoader from "react-spinners/ClipLoader";
import "./customers.scss";
import AddDeliveryInfoDialog from "./AddDeliveryInfoDialog";
import { handlePostRequest } from "../../services/PostTemplate";
function DeliveryInfos() {
    const location = useLocation();
    const [selectedRow, setselectedRow] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [brands, setBrands] = useState([]);
    const [skip, setSkip] = useState(0);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const history = useHistory();

    const getBrands = async () => {
        setLoading(true);
        const res = await handleGetRequest(`/getAllDeliveryInfo`);
        setBrands(res?.data);
        setLoading(false);
    };
    useMemo(() => {
        getBrands();
    }, [skip]);

    const handelDel = async (rowdata) => {
        const data={
            id: rowdata?._id,
        }
        const res = await dispatch(handlePostRequest(data,`/deleteDeliveryInfo`,true,true));
        if (res !== "error") {
            toast.success("Delivery information deleted");
            window.location.reload();
        }
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div>
                <Button icon="pi pi-ellipsis-v" className="p-button-rounded mr-2 Elipse_Icon" onClick={(e) => handleActionButton(e, rowData)} aria-controls="popup_menu" aria-haspopup />
                <Button icon="pi pi-trash" iconPos="right" onClick={() => handelDel(rowData)} className="Btn__DarkDelete" style={{ width: "40px", backgroundColor: "red", border: "none" }} />
            </div>
        );
    };
    const handleActionButton = (e, rowdata) => {
        e.preventDefault();
        history.push(`/DeliveryInfo/${rowdata?._id}`);
    };

    const onHideTyreBrandsDialog = () => {
        setShowDialog(false);
    };

    const onsuccess = () => {
        onHideTyreBrandsDialog();
        toast.success("delivery information added");
        window.location.reload();
    };

    return (
        <div className="delivery-page-wrapper">
            <Dialog visible={showDialog} header="Delivery Information" style={{ width: "650px" }} onHide={() => setShowDialog(false)}>
                <AddDeliveryInfoDialog onHideTyreBrandsDialog={onHideTyreBrandsDialog} onsuccess={onsuccess} />
            </Dialog>
            {/* <Dialog visible={showSoftStop} style={{ width: "650px" }} onHide={() => setShowSoftStop(false)}>
                <SofStop onHideSoftStop={onHideSoftStop} onSuccessSoftStop={onSuccessSoftStop} type="user"></SofStop>
            </Dialog> */}

            <div className="Page__Header">
                <div>
                    <h2>Delivery Information</h2>
                </div>
                <div className="Top__Btn">
                    <Tooltip
                        // options
                        title="Add new delivery info"
                        position="bottom"
                        trigger="mouseenter"
                        arrow={true}
                    >
                        <Button icon="pi pi-plus" iconPos="right" onClick={() => setShowDialog(true)} className="Btn__Blue" />
                    </Tooltip>
                </div>
            </div>
            <div className="card">
                <DataTable
                    filterDisplay="row"
                    paginator
                    rows={100}
                    rowsPerPageOptions={[100, 500, 1000]}
                    className="datatable-responsive custom-datatable"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                    emptyMessage="No List found."
                    // responsiveLayout="scroll"
                    value={brands}
                    selection={selectedRow}
                    onSelectionChange={(e) => setselectedRow(e.value)}
                    sortMode="multiple"
                    loadingIcon="pi pi-spinner"
                    loading={loading}
                    loadingTemplate={<ClipLoader color={"#2C4870"} loading={loading} size={30} />}
                    loadingText="Loading..."
                    style={{ Height: "100px", overflowY: "auto" }}
                >
                    <Column selectionMode="multiple" style={{ width: "3em" }} />
                    <Column header="Action" body={actionBodyTemplate} />
                    <Column filter field="name" header="Title" sortable />
                </DataTable>
            </div>
        </div>
    );
}

export default DeliveryInfos;
